import { render } from "./OmniBox.vue?vue&type=template&id=013fa457"
import script from "./OmniBox.vue?vue&type=script&lang=js"
export * from "./OmniBox.vue?vue&type=script&lang=js"

import "./OmniBox.vue?vue&type=style&index=0&id=013fa457&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__